import React from "react"

import { BadgeProps, Badge, BadgeVariant } from "@tfg/ui"

export type StatusBadgeProps = {
  icon: React.ReactNode
  variant?: (typeof BadgeVariant)[keyof typeof BadgeVariant]
  h?: string
  fw?: number
  size?: string
  fz?: string
  w?: string
  miw?: string | number
  iconSize?: number
} & BadgeProps

export const StatusBadge = ({
  text,
  icon,
  variant,
  fw = 600,
  size = "xs",
  fz = "xxs",
  h = "fit-content",
  p = "compact-xs",
  tt = "capitalize",
  iconSize = 16,
  ...props
}: StatusBadgeProps) => {
  const transformedText = text ? text.toLocaleUpperCase() : ""
  return (
    <Badge
      leftSection={
        React.isValidElement(icon)
          ? React.cloneElement(icon as React.ReactElement, {
              width: iconSize,
              height: 16,
            })
          : icon
      }
      size={size}
      fz={fz}
      fw={fw}
      variant={variant}
      h={h}
      p={p}
      tt={tt}
      text={transformedText}
      {...props}
    />
  )
}
